@if (isLoading()) {
  <div class="user-menu__skeleton">
    <xemex-skeleton-block [width]="'36px'" [height]="'36px'" [borderRadius]="'50%'" />
    <xemex-skeleton-block [width]="'90px'" [height]="'16px'" [borderRadius]="'4px'" />
  </div>
} @else {
  <button class="user-menu__trigger" [matMenuTriggerFor]="menu" aria-label="Open user menu">
    <xemex-avatar class="user-menu__avatar" [src]="userAvatar()" [alt]="userName()" />
    <span class="user-menu__identity">
      @if (userName()) {
        <span class="user-menu__name">{{ userName() }}</span>
      }
      @if (activePartnerName()) {
        <span class="user-menu__active-partner">{{ activePartnerName() }}</span>
      }
    </span>
  </button>
}

<mat-menu #menu="matMenu" xPosition="before">
  <div class="user-menu__panel">
    <button mat-menu-item class="user-menu__item" (click)="aboutClick.emit()">
      <mat-icon class="user-menu__item-icon">info</mat-icon>
      <span>About</span>
    </button>

    <button mat-menu-item class="user-menu__item" (click)="profileClick.emit()">
      <mat-icon class="user-menu__item-icon">person</mat-icon>
      <span>My Profile</span>
    </button>

    @if (partners().length > 1) {
      <div class="user-menu__section">
        <span class="user-menu__section-label">Switch account</span>
        @for (partner of partners(); track partner.partnerOid) {
          <button
            mat-menu-item
            class="user-menu__item user-menu__item--partner"
            (click)="partnerSelect.emit(partner)"
          >
            <div class="user-menu__partner">
              <div class="user-menu__partner-avatar">
                {{ partner.partnerName.charAt(0).toUpperCase() }}
              </div>
              <div class="user-menu__partner-info">
                <span class="user-menu__partner-name">{{ partner.partnerName }}</span>
              </div>
              <mat-radio-button class="user-menu__partner-radio" [checked]="partner.is_active" />
            </div>
          </button>
        }
      </div>
    }

    <button mat-menu-item class="user-menu__item user-menu__item--danger" (click)="logout.emit()">
      <mat-icon class="user-menu__item-icon user-menu__item-icon--danger">logout</mat-icon>
      <span>Logout</span>
    </button>
  </div>
</mat-menu>
